import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { accountInformation } from '../../../../../../redux/slices/authSlice';
import { eventsModalstoggleVisibilitySlice } from '../../../../../../redux/slices/eventsModalstoggleVisibilitySlice';
import {
  favoritesInformation,
  favoritesSlice,
  filterButton
} from '../../../../../../redux/slices/favoritesSlice';
import { filtersInformation } from '../../../../../../redux/slices/filtersSlice';
import FilterUtils from '../../../../../../utils/FilterUtils';
import { VM } from '../../../../../../viewmodel/VM';
import ButtonIcon from '../../../../../components/commons/ButtonIcon';
import DefaultModal from '../../../../../components/widget/Modals/DefaultModal';
import { useTranslate } from '../../../../../context/languageContext';
import { useSetModalChild, useSetModalOpened } from '../../../../../context/modalContext';
import { R } from '../../../../../R';
import GeneralUtils from '../../../../../../utils/GeneralUtils';
import { markersSlice } from '../../../../../../redux/slices/markersSlice';

export default function FilterButton(props: any) {
  const activeFilterButton = useSelector(filterButton);
  const account = useSelector(accountInformation);
  const setChild = useSetModalChild();
  const setOpen = useSetModalOpened();
  const t = useTranslate();
  const dispatch = useDispatch();
  const filters = useSelector(filtersInformation);
  const favorites = useSelector(favoritesInformation);

  useEffect(() => {
    if (!favorites.agencyId?.length) dispatch(favoritesSlice.actions.setFilterButton(false));
    FilterUtils.filterByTransport(
      filters.modes,
      filters.operators,
      favorites.agencyId,
      activeFilterButton
    );
  }, [favorites.agencyId, filters]);

  const getTransportIcon = () => {
    if (!favorites.agencyId?.length) {
      return R.drawables.general.Ic_myTransportNo;
    } else if (activeFilterButton) {
      return R.drawables.general.Ic_myTransportSel;
    } else return R.drawables.general.Ic_myTransportYes;
  };

  const onClick = () => {
    if (account.idUserType === 1) {
      setOpen(true);
      setChild(
        <DefaultModal
          title={t('login2')}
          description={t('loginToFavBody')}
          alter={true}
          firstButton={t('createAccount')}
          secondButton={t('login')}
          onClickFirst={() => {
            dispatch(
              eventsModalstoggleVisibilitySlice.actions.toggleVisibilityPersonalInformationModalWidget(
                true
              )
            );
          }}
          onClickSecond={() => {
            dispatch(
              eventsModalstoggleVisibilitySlice.actions.toggleVisibilityLoginModalWidget(true)
            );
          }}
        />
      );
    } else if (!favorites.agencyId?.length) {
      setOpen(true);
      setChild(
        <DefaultModal
          title={t('noTransportSaved')}
          description={t('noTransportSavedBody')}
          alter={true}
          firstButton={t('close')}
          secondButton={t('goToFav')}
          onClickSecond={() => {
            VM.screenSelected.setSection(3);
            VM.screenSelected.setSelected('favorites');
            GeneralUtils.setLastSectionPath('operators',1);
          }}
        />
      );
    } else {
      dispatch(favoritesSlice.actions.setFilterButton(!activeFilterButton));
      filterByTransport(
        filters.modes,
        filters.operators,
        favorites.agencyId,
        !activeFilterButton, 
        []
      );
    }
  };

  async function filterByTransport(modesF:any, operatorsF:any, favOperators:any, isFilterButton:any, motorized:any[]) {
      let modes : any = [];
      let operators = [];
      let result = [];
  
      if (isFilterButton) {
        operators = favOperators;
      } else {
        operators = operatorsF;
        modes = JSON.parse(JSON.stringify(modesF));  
        if (motorized?.find(element => element === 1) && motorized?.find(element => element === 2) === undefined) {
          //combutión
          [1, 2].forEach((element) => {
            if (modes.find((mode:any) => mode === element) === undefined) {
              modes.push(element)
            }
          })
        } else if (motorized?.find(element => element === 1) === undefined && motorized?.find(element => element === 2)) {
          //electrico
          [1, 2, 3, 7, 8, 10].forEach((element) => {
            if (modes.find((mode:any) => mode === element)  === undefined) {
              modes.push(element)
            }
          })
        }
        
      }
  
      if (operators.length) {
        for (let stop in VM.stops.noFiltered) {
          let agencyOriginId = VM.stops.noFiltered[stop].agencyOriginId;
          if (operators.indexOf(agencyOriginId) >= 0) {
            result.push(VM.stops.noFiltered[stop]);
          }
        }
        //VM.stops.notify(result, true);
      } else {
        result = VM.stops.noFiltered
      }
  
      let newResult = [];
  
      if (modes.length) {
        for (let stop in result) {
          let transportMode = result[stop].transportMode;
          if (modes.find((transport:any) => transport === transportMode)) {
            newResult.push(result[stop]);
          }
        }
      } else {
        newResult = result;
      }
      console.log("dentro del else: newResult: ", newResult);
  
      VM.stops.notify(newResult, true);
      dispatch(markersSlice.actions.updateStopsFiltered(newResult));
      
      // else VM.stops.notify(VM.stops.noFiltered, true);
    }

  return (
    <div className="filterButton">
      <ButtonIcon icon={getTransportIcon()} selected={activeFilterButton} onClick={onClick} />
    </div>
  );
}
